import { Typography } from "@c4c-web/ui";
import { BriefcaseIcon, HouseIcon, PinIcon } from "@c4c-web/icons";
import { EAddressType } from "../../../constants";
import type { TranslationFn } from "../../../types";

export const AddressTypeChips = (
  addressType: string[],
  t: TranslationFn,
): { label: JSX.Element; value: string }[] => [
  {
    label: (
      <div className="flex flex-col items-center px-md">
        <HouseIcon
          color={
            addressType[0] === EAddressType.HOME.toString()
              ? "primary"
              : "black"
          }
          variant="thin"
        />
        <Typography variant="md">
          {t("addressJourney.addressForm.home")}
        </Typography>
      </div>
    ),
    value: EAddressType.HOME,
  },
  {
    label: (
      <div className="flex flex-col items-center px-md">
        <BriefcaseIcon
          color={
            addressType[0] === EAddressType.OFFICE.toString()
              ? "primary"
              : "black"
          }
          variant="thin"
        />
        <Typography variant="md">
          {t("addressJourney.addressForm.office")}
        </Typography>
      </div>
    ),
    value: EAddressType.OFFICE,
  },
  {
    label: (
      <div className="flex flex-col items-center px-md">
        <PinIcon
          color={
            addressType[0] === EAddressType.OTHER.toString()
              ? "primary"
              : "black"
          }
          variant="thin"
        />
        <Typography variant="md">
          {t("addressJourney.addressForm.other")}
        </Typography>
      </div>
    ),
    value: EAddressType.OTHER,
  },
];
